import React, { useEffect, useState } from "react";
import {Navigate, useLocation} from "react-router-dom";

const isTokenExpired = (token) => {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    return decoded.exp * 1000 < Date.now();
};

const getRemainingTime = (token) => {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = decoded.exp * 1000;
    return Math.max(0, Math.floor((expirationTime - Date.now()) / 1000));
};

const PrivateRoute = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem('accessToken');
    const isTokenValid = token && !isTokenExpired(token);

    const [remainingTime, setRemainingTime] = useState(null);
    const [showCountdownMessage, setShowCountdownMessage] = useState(false);

    useEffect(() => {
        if (token) {
            const interval = setInterval(() => {
                const timeLeft = getRemainingTime(token);
                setRemainingTime(timeLeft);

                if (timeLeft <= 60 && timeLeft > 0) {
                    setShowCountdownMessage(true);
                } else {
                    setShowCountdownMessage(false);
                }

                if (timeLeft <= 0) {
                    clearInterval(interval);
                    setShowCountdownMessage(false);
                    localStorage.removeItem('accessToken');
                    window.location.reload();
                }
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [token]);

    if (isTokenValid) {
        return (
            <>
                {showCountdownMessage && (
                    <div className="countdown-message bg-yellow-500 text-black p-2 rounded-md mb-4">
                        Token is expiring in less than a minute!
                    </div>
                )}
                {children}
            </>
        );
    } else {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
};

export default PrivateRoute;
